export default __webpack_public_path__ + "static/media/anh-ngang.fc17068e.jpg";